module.exports = __webpack_public_path__ + "img/xmwj.27e4567c.png";